import PropTypes from 'prop-types';
import React from 'react';

import NativeImage from '$partials/media/native-image.jsx';

const OrganisationItem = ({
    className = '',
    websiteUrl,
    linkedinUrl,
    listingImage,
    standfirst,
    twitterUrl,
    title
}) => {

    return (
        <div className={`h-full min-h-[220px] sm:min-h-[260px] md:min-h-[280px] bg-white flex flex-col rounded-s-lg sm:rounded-lg px-25 py-30 sm:px-20 sm:py-25 md:px-25 md:py-35 expand-interaction ${className}`}>
            <a
                aria-label={title}
                className='expand-interaction__action flex-1'
                href={websiteUrl}
                rel='noreferrer noopener'
                target='_blank'>
                {listingImage ? (
                    <>
                        <div className='relative'>
                            <div
                                className='overflow-hidden relative'>
                                <NativeImage
                                    className='object-contain object-left-top h-50 w-full'
                                    {...listingImage} />
                            </div>
                        </div>
                        <div className='mt-20'>
                            {standfirst &&
                            <p className='mt-5'>
                                {standfirst}
                            </p>
                            }
                        </div>
                    </>
                ) : (
                    <>
                        <div
                            className='type-style-4'
                            style={{ fontWeight: '400' }}>
                            {title}
                        </div>
                        <div className='mt-45 md:mt-35'>
                            {standfirst &&
                            <p className='mt-5'>
                                {standfirst}
                            </p>
                            }
                        </div>
                    </>
                )}
            </a>

            {/* Share Links */}
            <div className='flex pt-25 md:pt-30 type-style-8'>
                {websiteUrl && (
                    <>
                        <a
                            className=''
                            href={websiteUrl}
                            rel='noreferrer noopener'
                            target='_blank'>
                            Website
                        </a>
                        {(linkedinUrl || twitterUrl) && (
                            <span>&nbsp;·&nbsp;</span>
                        )}
                    </>
                )}
                {linkedinUrl && (
                    <>
                        <a
                            className=''
                            href={linkedinUrl}
                            rel='noreferrer noopener'
                            target='_blank'>
                            LinkedIn
                        </a>
                        {twitterUrl && (
                            <span>&nbsp;·&nbsp;</span>
                        )}
                    </>
                )}
                {twitterUrl && (
                    <>
                        <a
                            className=''
                            href={twitterUrl}
                            rel='noreferrer noopener'
                            target='_blank'>
                            X
                        </a>
                    </>
                )}
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    className: PropTypes.string,
    websiteUrl: PropTypes.string,
    linkedinUrl: PropTypes.string,
    listingImage: PropTypes.object,
    standfirst: PropTypes.string,
    openToModal: PropTypes.bool,
    title: PropTypes.string,
    twitterUrl: PropTypes.string,
    url: PropTypes.string,
};

OrganisationItem.propTypes = propTypes;

export default OrganisationItem;
